import { IconButton, Tooltip } from '@patrianna/core-components'
import type { Currency } from '@patrianna/shared-patrianna-types/store/CurrenciesModule'
import { intlnumberFormat } from '@patrianna/shared-utils/numbers'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { InformationOutline } from '@patrianna-icons/material-icons'

import content from 'prismic-translates/common.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  balances: Currency
}

function SweepToolTipTitle(props: { balances: Currency }) {
  if (props.balances) {
    return (
      <>
        <p className={`mt-typography-caption mt-typography-alignCenter ${classes.paragraph}`}>
          {t('more_sc_description')}
        </p>
        <p className='mt-typography-caption mt-typography-alignCenter'>
          {t('sweep_item_title1')}: SC
          {intlnumberFormat(props.balances.amount, 'en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
          })}
        </p>
        <p className='mt-typography-caption mt-typography-alignCenter'>
          {t('sweep_item_title2')}: SC
          {intlnumberFormat(props.balances.redeemable, 'en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
          })}
        </p>
        <p className='mt-typography-caption mt-typography-alignCenter'>
          {t('sweep_item_title3')}: SC
          {intlnumberFormat(props.balances.unplayed, 'en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
          })}
        </p>
      </>
    )
  }

  return null
}

export default function SweepTooltip(props: Props) {
  return (
    <Tooltip className={classes.tooltip} delay={8000} title={<SweepToolTipTitle balances={props.balances} />}>
      <IconButton className={classes.link}>
        <InformationOutline />
      </IconButton>
    </Tooltip>
  )
}
